import { AuthProvidersEnum } from '@repo/db/schema'
import { z } from 'zod'

export const LoginSchema = z.object({
  intent: z.literal('login'),
  provider: AuthProvidersEnum,
  timezone: z.string(),
  redirectTo: z.string().optional()
})
